import React, { useMemo } from 'react';
import { EventNameNav, EventNameNavProps } from '../components/EventNameNav';
import { WebsiteHeaderLayout_PhotoDuoRight } from '../../../../hooks/useWebsiteHeaderSettings';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import { PhotoDuo } from '@apps/guest/packages/layout-engine/widgets/Custom/components';

interface PhotoDuoRightLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_PhotoDuoRight;
  showPlaceholder?: boolean;
}

export const PhotoDuoRightLayout = (props: PhotoDuoRightLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  const photos = useMemo(() => {
    return websiteHeader.headerPhoto.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || [];
  }, [websiteHeader]);

  return (
    <EventNameNav eventDisplayName={websiteHeader.eventDisplayName} {...restProps}>
      <HeaderPhoto websiteHeader={websiteHeader} pageSlug={restProps.pageSlug} pageType={restProps.page} showPlaceholder={showPlaceholder}>
        <PhotoDuo photos={photos} showPlaceholder={showPlaceholder} arrangement="right" />
      </HeaderPhoto>
    </EventNameNav>
  );
};
